import React from 'react'

import { ExcessDeathRegion as Component } from './component'
//
const ExcessDeathRegion = props => {
  return <Component {...props} />
}
export default ExcessDeathRegion
